module.exports = __webpack_public_path__ + "assets/img/master-distributer.ee1e693f.svg";